import React, { useEffect } from "react";
import styled from "styled-components";
import { Bio } from "../../Data/Constants";
import {
  FacebookRounded,
  Instagram,
  LinkedIn,
  Twitter,
} from "@mui/icons-material";

import Aos from "aos";
import "aos/dist/aos.css";

const FooterContainer = styled.div`
  width: 100%;
  padding: 2rem 0;
  display: flex;
  justify-content: center;
  z-index: 10;
  position: relative;
`;

const FooterWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  padding: 1rem;
  color: ${({ theme }) => theme.text_primary};
`;

const Logo = styled.a`
  font-weight: 600;
  font-size: 20px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;
`;

const Nav = styled.ul`
  width: 100%;
  max-width: 800px;
  margin-top: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 2rem;
  justify-content: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    text-align: center;
    font-size: 12px;
  }
`;

const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  text-decoration: none;
  font-size: 1.2rem;
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  margin-top: 1rem;
`;

const SocialMediaIcon = styled.a`
  display: inline-block;
  margin: 0 1rem;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_primary};
  transition: color 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

const Footer = () => {
  const name = "<Ido \\ sulam>";

  useEffect(() => {
    Aos.init();
  });

  return (
    <FooterContainer>
      <FooterWrapper>
        <Logo data-aos="zoom-in" data-aos-once="true" href="#About">
          {name}
        </Logo>
        <Nav>
          <NavLink href="#About" data-aos="zoom-in" data-aos-once="true">
            About
          </NavLink>
          <NavLink href="#Skills" data-aos="zoom-in" data-aos-once="true">
            Skills
          </NavLink>
          <NavLink href="#Experience" data-aos="zoom-in" data-aos-once="true">
            Experience
          </NavLink>
          <NavLink href="#Projects" data-aos="zoom-in" data-aos-once="true">
            Projects
          </NavLink>
          <NavLink href="#Education" data-aos="zoom-in" data-aos-once="true">
            Education
          </NavLink>
        </Nav>
        <SocialMediaIcons>
          {Bio.facebook && Bio.facebook.length > 0 && (
            <SocialMediaIcon href={Bio.facebook} target="display">
              <FacebookRounded />
            </SocialMediaIcon>
          )}
          {Bio.twitter && Bio.twitter.length > 0 && (
            <SocialMediaIcon href={Bio.twitter} target="display">
              <Twitter />
            </SocialMediaIcon>
          )}
          {Bio.linkedin && Bio.linkedin.length > 0 && (
            <SocialMediaIcon href={Bio.linkedin} target="display">
              <LinkedIn />
            </SocialMediaIcon>
          )}
          {Bio.insta && Bio.insta.length > 0 && (
            <SocialMediaIcon href={Bio.insta} target="display">
              <Instagram />
            </SocialMediaIcon>
          )}
        </SocialMediaIcons>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default Footer;
